import * as React from "react";

import { cn } from "@/lib/utils";

// Native <input type="file"> etiketleri ("Choose file / No file chosen")
// tarayicinin diline bagli, CSS/HTML ile degistirilemiyor. Bu bilesen
// native input'u gizleyip Turkce bir buton + dosya adi gosterir.
const FileInput = React.forwardRef(
  (
    {
      className,
      id,
      buttonLabel = "Dosya Seç",
      emptyLabel = "Dosya seçilmedi",
      onChange,
      disabled,
      ...props
    },
    ref
  ) => {
    const [fileName, setFileName] = React.useState("");

    const handleChange = (event) => {
      // Tuketici onChange icinde dosyayi reddedip input'u temizleyebilir
      // (event.target.value = null), bu yuzden adi ondan sonra okuyoruz.
      onChange?.(event);
      setFileName(event.target.files?.[0]?.name || "");
    };

    return (
      <div
        className={cn(
          "flex h-10 w-full items-center gap-2 rounded-md border border-input bg-background px-1 py-1 text-sm ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
          disabled && "cursor-not-allowed opacity-50",
          className
        )}
      >
        <label
          htmlFor={id}
          className={cn(
            "shrink-0 cursor-pointer rounded-sm bg-secondary px-3 py-1.5 text-sm font-medium text-secondary-foreground hover:bg-secondary/80",
            disabled && "pointer-events-none"
          )}
        >
          {buttonLabel}
        </label>
        <span
          className={cn(
            "truncate",
            fileName ? "text-foreground" : "text-muted-foreground"
          )}
        >
          {fileName || emptyLabel}
        </span>
        <input
          {...props}
          id={id}
          ref={ref}
          type="file"
          disabled={disabled}
          className="sr-only"
          onChange={handleChange}
        />
      </div>
    );
  }
);
FileInput.displayName = "FileInput";

export { FileInput };
